export const ORIGINS = ["Assam", "Dooars", "Terai", "Darjeeling", "Other"];

export const APPLICATIONS = [
  { value: "retail_pack", label: "Retail Pack" },
  { value: "loose_tea", label: "Loose Tea" },
  { value: "tea_stall_hotel", label: "Tea Stall / Hotel" },
  { value: "milk_tea_blend", label: "Milk-Tea Blend" },
  { value: "premium_blend", label: "Premium Blend" },
  { value: "wholesale_supply", label: "Wholesale Supply" },
  { value: "export", label: "Export" },
  { value: "private_label", label: "Private Label" },
  { value: "institutional_supply", label: "Institutional Supply" },
  { value: "blending_purpose", label: "Blending Purpose" },
];

export const APP_LABELS = Object.fromEntries(APPLICATIONS.map((a) => [a.value, a.label]));

export const TEA_CATEGORIES = ["CTC", "Orthodox", "Green", "White", "Oolong", "Dust", "Other"];
export const SAMPLE_TYPES = ["Bulk", "Sample", "Auction", "Private", "Trial"];
export const CERTIFICATIONS = ["FSSAI", "Organic", "ISO 22000", "HACCP", "Rainforest Alliance", "Trustea", "None"];

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  ready: { label: "Ready", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  shared: { label: "Shared", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  archived: { label: "Archived", cls: "bg-stone-200 text-stone-700 border-stone-400" },
};

export const roleLabel = (r) => (r === "admin" ? "Administrator" : "Sales Executive");

export const MAX_PRODUCTS = 15;

// " + 5% GST" style suffix for a product's rate, or "" when no GST is set
export const gstSuffix = (p) => {
  const g = (p?.gst_percent ?? "").toString().trim();
  return g && g !== "0" ? ` + ${g}% GST` : "";
};

// "₹189/kg incl." when both price and GST are numeric, else ""
export const gstInclusive = (p) => {
  const base = Number(p?.price_per_kg);
  const g = Number(p?.gst_percent);
  if (!isFinite(base) || !base || !isFinite(g) || !g) return "";
  const inc = base * (1 + g / 100);
  const s = Number.isInteger(inc) ? String(inc) : inc.toFixed(2).replace(/\.?0+$/, "");
  return `₹${s}/kg incl.`;
};


// WhatsApp number shown on chat buttons: the catalogue's manually entered number, else the brand's
export const chatNumber = (cat, brand) => String(cat?.whatsapp_number || brand?.whatsapp || brand?.phone || "").trim();

// wa.me deep link for a phone number with a prefilled message ("" when none); 10 digits → +91
export const waUrl = (number, text) => {
  let d = String(number || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 10) d = `91${d}`;
  return `https://wa.me/${d}?text=${encodeURIComponent(text)}`;
};

export const sampleRequestText = (p, n, catalogueNumber) => {
  const tea = [p.brand_group || p.garden || p.name, p.grade].filter(Boolean).join(" · ");
  return `Hello Prime Gold Tea, I would like to request a sample of Product ${n} — ${tea}${catalogueNumber ? ` from Catalogue ${catalogueNumber}` : ""}.`;
};
